module.exports = require("querystring-browser");